module.exports = __webpack_public_path__ + "static/logo_active_30th@2x-bf93e28bab61b440b4527f6bde4e407e.png";